/**
 * Back ends at Home.
 *
 * Every screen the drawer opens sits directly on Home, and a confirmation
 * trims the checkout it finished from under itself, so pressing back — the
 * header's arrow, Android's button or a swipe — from anywhere, as many times
 * as it takes, arrives at Home rather than at a menu screen visited earlier or
 * back inside a checkout that has been paid.
 */

import { useEffect } from 'react';
import { CommonActions, type NavigationProp, type ParamListBase } from '@react-navigation/native';

import type { DonorStackParamList } from './types';

/** The drawer's stack, reset to Home with `route` on top of it. */
export function homeThen(route: keyof DonorStackParamList) {
  return CommonActions.reset({
    index: 0,
    routes: [
      {
        name: 'Main',
        state: {
          index: route === 'Home' ? 0 : 1,
          routes: route === 'Home' ? [{ name: 'Home' }] : [{ name: 'Home' }, { name: route }],
        },
      },
    ],
  });
}

/** Leave only Home under the screen showing. */
export function useHomeUnderneath(navigation: NavigationProp<ParamListBase>) {
  useEffect(() => {
    const state = navigation.getState();
    const current = state?.routes[state.index];
    if (!state || !current) return;
    if (state.index === 1 && state.routes[0]?.name === 'Home') return;
    navigation.dispatch(
      CommonActions.reset({
        ...state,
        index: 1,
        routes: [{ name: 'Home' }, current],
      }),
    );
  }, [navigation]);
}
